class FilterTab extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
  }
  connectedCallback(){
    console.log(this.querySelectorAll('.text-wrapper'),1111)
    this.querySelectorAll('.text-wrapper').forEach((item,index)=>{
       if(item.getAttribute('data-type')){
        console.log(item)
        item.onclick =()=>{
            if(this.querySelectorAll('.text-wrapper')[this.index] && this.querySelectorAll('.text-wrapper')[this.index].classList.contains('is-active')){
                this.querySelectorAll('.text-wrapper')[this.index].classList.remove('is-active');
            }
            item.classList.add('is-active');
            this.index = index;
            this.filterCardProduct(item.getAttribute('data-type'));
        }
       }
    })
  }
  filterCardProduct(tip){
    document.querySelectorAll('card-product').forEach(item=>{
        if(item.classList.contains(tip)){
            item.classList.remove('hidden')
        }
        else{
            item.classList.add('hidden');
        }
    })
  }
}
customElements.define('filter-tab', FilterTab);
